// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"32":"f6f2df7d","245":"component---src-pages-index-tsx","377":"2e3a845b","564":"2bd5012a","883":"7112840a"}[chunkId] + "-" + {"32":"32358c0fd0e267e81844","245":"338658f4d23d5865d153","377":"eabf20768702d79b6ab7","564":"f8e95f7e770bdfcc1506","883":"9b72d600d9e5ab19beea"}[chunkId] + ".js";
};